function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { gsap, Power4 } from 'gsap';
export var homepageHeroBehavior = function homepageHeroBehavior() {
  Alpine.data('homepageHeroBehavior', function () {
    return {
      $homepageHero: false,
      $siteHeader: false,
      searchHeroOpen: false,
      activeSearchHero: '',
      searchHeroes: {},
      init: function init() {
        this.$homepageHero = this.$el;
        this.$siteHeader = document.querySelector('.o-header');

        if (this.$siteHeader) {
          this.$el.style.maxHeight = "calc(100vh - ".concat(this.$siteHeader.offsetHeight, "px)");
        }
      },
      openHero: function openHero(ref) {
        if (this.activeSearchHero) {
          // Ensure any open heroes are closed before opening another.
          this.closeHero(this.activeSearchHero);
        }

        this.activeSearchHero = ref;
        this.searchHeroes[ref].active = true;
        this.searchHeroes[ref].animationTimeline.play();
        this.$homepageHero.classList.add('o-homepage-hero--search-hero-active');
      },
      closeHero: function closeHero(ref) {
        if (this.searchHeroes[ref].animationTimeline) {
          this.searchHeroes[ref].animationTimeline.reverse();
        }

        this.activeSearchHero = '';
      },
      heroAnimation: function heroAnimation(ref) {
        var _this = this;

        if (this.searchHeroes[ref]) {
          var element = this.searchHeroes[ref].element;
          var animationTimeline = this.searchHeroes[ref].animationTimeline;
          animationTimeline = gsap.timeline({
            paused: true
          });
          var fromVars = {
            y: '66%',
            scale: 1.33,
            opacity: 0,
            display: 'none'
          };
          var toVars = {
            y: '0%',
            scale: 1,
            opacity: 1,
            display: 'block',
            ease: Power4.easeInOut,
            duration: 0.5,
            onStart: function onStart() {
              _this.$homepageHero.classList.add('o-homepage-hero--search-hero-active');
            },
            onComplete: function onComplete() {
              _this.searchHeroOpen = true;
              document.body.classList.add('overflow-hidden');
            },
            onReverseComplete: function onReverseComplete() {
              _this.searchHeroOpen = false;
              document.body.classList.remove('overflow-hidden');

              _this.$homepageHero.classList.remove('o-homepage-hero--search-hero-active');
            }
          };
          animationTimeline.fromTo(element, fromVars, toVars);
          this.searchHeroes[ref].animationTimeline = animationTimeline;
        }
      },
      buttonEvents: {
        // eslint-disable-next-line func-names
        'x-init': function xInit() {
          var ref = this.$el.getAttribute('data-search-hero-ref');
          this.searchHeroes[ref] = _objectSpread(_objectSpread({}, this.searchHeroes[ref]), {}, {
            triggerButton: this.$el
          });
        },
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          var ref = this.$el.getAttribute('data-search-hero-ref');
          this.openHero(ref);
        }
      },
      searchHero: {
        // eslint-disable-next-line func-names
        'x-init': function xInit() {
          var ref = this.$el.getAttribute('x-ref');
          this.searchHeroes[ref] = _objectSpread(_objectSpread({}, this.searchHeroes[ref]), {}, {
            active: false,
            element: this.$el,
            animationTimeline: false
          });
          this.heroAnimation(ref);
        }
      }
    };
  });
};